import { discoverArticlePath } from '@/lib/discover/path';

/**
 * Pure link + visibility rules for the post inspector's connections to the
 * rest of Mora (approval round-trip, performance, source story, plan).
 * Kept out of PostBody.tsx so each rule is testable on its own.
 */

/** Statuses for which "Send for approval" makes no sense: the post is already out. */
const NOT_APPROVABLE = new Set(['published', 'partially_published']);

export function canSendPostForApproval(status: string | null | undefined): boolean {
  return !NOT_APPROVABLE.has(status ?? 'draft');
}

/** "See performance" is for a post that actually went out. */
export function canSeePostPerformance(status: string | null | undefined): boolean {
  return status === 'published' || status === 'partially_published';
}

/**
 * Insights has no single-post deep link: `PostAnatomySheet` takes a full
 * `PostEngagement` row that only the Insights data hooks build, so the honest
 * seam is the overview page itself.
 */
export const POST_PERFORMANCE_HREF = '/insights/overview';

/**
 * `/discover/:slug` accepts a bare article UUID (see `src/lib/discover/path.ts`),
 * so `social_posts.source_article_id` alone is enough.
 */
export function sourceArticleHref(articleId: string | null | undefined): string | null {
  const id = articleId?.trim();
  return id ? discoverArticlePath(id) : null;
}

export function planHref(projectId: string | null | undefined): string | null {
  const id = projectId?.trim();
  return id ? `/projects/${id}` : null;
}
